import { Component, OnInit, OnDestroy, Renderer2 } from '@angular/core';
import { Subscription } from 'rxjs';
import { JoinService } from '../../core/services/join/join.service';
import { ScriptService } from '../../core/services/script/script.service';
import { scripts } from '../../shared/constants/script.constant';
import { environment } from '../../../environments/environment';
import { resetUserToken, startUserSessionMonitor } from '../../shared/utitlity-functions/utility-functions';
import { UserDataService } from '../../core/services/user-data/user-data.service';
import * as moment from 'moment';

@Component({
    standalone: false,
    selector: 'octo-mail-in-process',
    templateUrl: './mail-in-process.component.html',
    styleUrls: ['./mail-in-process.component.scss'],
})
export class MailInProcessComponent implements OnInit, OnDestroy {
    trackingNumber: any = '';
    deliveryDate: any = 'In Processing';
    userData$ = new Subscription();
    adlibTag: any;
    fbPixelUs: any;
    fbPixelUsNoScript: any;
    fbPixelCanada: any;
    fbPixelCanadaNoScript: any;
    paymentInfo: any;
    joinData: any;
    address: any;
    referral_code: any;
    referral_link: any;

    constructor(
        private readonly joinService: JoinService,
        private readonly renderer: Renderer2,
        private readonly scriptService: ScriptService,
        private readonly userDataService: UserDataService
    ) {}

    ngOnInit(): void {
        resetUserToken();
        startUserSessionMonitor();
        if (environment.production && environment.shouldAddPixel) {
            // pixel scripts
            this.adlibTag = this.scriptService.loadJsScript(
                this.renderer,
                scripts.adlib
            );
            this.fbPixelUs = this.scriptService.loadJs(
                this.renderer,
                scripts['fb-us']
            );
            this.fbPixelUsNoScript = this.scriptService.loadNoScriptImg(
                this.renderer,
                scripts['fb-image-us']
            );
            this.fbPixelCanada = this.scriptService.loadJs(
                this.renderer,
                scripts['fb-canada']
            );
            this.fbPixelCanadaNoScript = this.scriptService.loadNoScriptImg(
                this.renderer,
                scripts['fb-image-canada']
            );
        }

        this.userData$ = this.joinService
            .getUserData()
            .subscribe((data: any) => {
                this.joinData = data;
                if (data?.shipping_info.is_fedex_pickup) {
                    this.address =
                        data?.shipping_info?.fedex_location?.location_name +
                            ', ' +
                            data?.shipping_info?.fedex_location?.address ||
                        'Unable to fetch FedEx Pickup location';
                    this.address = this.address.toUpperCase();
                    this.referral_code = data?.referral_code;
                    this.referral_link = data?.referral_link;
                } else {
                    let dat = [
                        data?.shipping_info.mailing_address_line,
                        data?.shipping_info.mailing_address_apartment_suite_no,
                        data?.shipping_info.mailing_address_city,
                        data?.shipping_info.mailing_address_state,
                        data?.shipping_info.mailing_address_country,
                        data?.shipping_info.mailing_address_zip,
                    ];
                    let notNullData = dat.filter((x) => x !== null && x !== undefined);
                    this.address = notNullData.join(' ');
                }

                if (data?.estimated_delivery_date)
                    this.deliveryDate = moment(
                        data?.estimated_delivery_date
                    ).format('MM/DD');
                if (data?.shipping_info?.tracking_number)
                    this.trackingNumber = data?.shipping_info?.tracking_number;
            });
        this.userDataService.fetchPayments({}).subscribe((data) => {
            this.paymentInfo = data?.data;
        });
    }
    ngOnDestroy(): void {
        this.userData$.unsubscribe();
        if (environment.production && environment.shouldAddPixel) {
            this.scriptService.removeScript(this.renderer, this.adlibTag);
            this.scriptService.removeScript(this.renderer, this.fbPixelUs);
            this.scriptService.removeScript(
                this.renderer,
                this.fbPixelUsNoScript
            );
            this.scriptService.removeScript(this.renderer, this.fbPixelCanada);
            this.scriptService.removeScript(
                this.renderer,
                this.fbPixelCanadaNoScript
            );
        }
    }
}
